import { Flex, Layout } from 'antd';
import { ReactNode } from 'react';
import styles from './public.layout.module.scss';
import Icon from '@ant-design/icons';
import Star from '@/assets/icons/stars-01.svg?react';
import bubbleSvg from '@/assets/images/bubble.svg?url';
import bubble1Svg from '@/assets/images/bubble-1.svg?url';

interface PublicLayoutProps {
  children: ReactNode;
}

const { Content } = Layout;

export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <Layout hasSider data-testid="public-layout">
      <Flex className={styles.sider}>
        <img className={styles.bubble} src={bubbleSvg} />
        <img className={styles.bubble1} src={bubble1Svg} />

        <Icon className={styles.stars} component={Star} />
        <h1 className={styles.heading}>AI Powered Contact Solutions</h1>
        <p className={styles.text}>
          Say goodbye to long wait times and frustrated customers. Experience increased efficiency
          and customer satisfaction like never before.
        </p>
      </Flex>
      <Layout data-testid="public-layout-content">
        <Content className={styles.content}>{children}</Content>
      </Layout>
    </Layout>
  );
}
